import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import {} from '@angular/fire';
import { AngularFireStorage } from '@angular/fire/storage';

import { EventModel } from '../models/event.model';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  eventList: Array<EventModel> = [];

  constructor(
    private storage: AngularFireStorage,
    private firestore: AngularFirestore
  ) {}

  createEvent(event: EventModel) {
    return this.firestore.collection('/events').add(event);
  }

  updateEvent(eventId, event: EventModel) {
    return this.firestore.collection('/events').doc(eventId).update(event);
  }

  deleteEvent(id) {
    this.firestore.collection('/events').doc(id).delete();
  }

  getEvents() {
    return this.firestore
      .collection('/events', (ref) => ref.orderBy('date1', 'desc'))
      .snapshotChanges();
  }

  getUpcomingEvents() {
    return this.firestore
      .collection('/events', (ref) => ref.orderBy('date1', 'asc'))
      .snapshotChanges();
  }

  getHomeEvents() {
    return this.firestore
      .collection('/events', (ref) => ref.orderBy('date1', 'asc').limit(50))
      .snapshotChanges();
  }

  getEventsById(eventId) {
    return this.firestore.collection('/events').doc(eventId).snapshotChanges();
  }

  public uploadImage(nombreArchivo: string, datos: any) {
    return this.storage.upload(nombreArchivo, datos);
  }

  public refImg(nombreArchivo: string) {
    return this.storage.ref(nombreArchivo);
  }
}
